import {DAY_MS, iso, makeShareToken, country, EUROPE_COUNTRIES, MOCK_ICCID, MOCK_DOMAIN_ID, MOCK_ACTIVATION_CODE, MOCK_RESELLER_INFORMATION} from "./shared";

const GLOBAL_COUNTRIES = [
    ...EUROPE_COUNTRIES,
    country("US", "United States"), country("CA", "Canada"), country("JP", "Japan"),
    country("AU", "Australia"), country("BR", "Brazil"), country("CN", "China"),
    country("IN", "India"), country("ZA", "South Africa"), country("MX", "Mexico"),
    country("KR", "South Korea"), country("SG", "Singapore"), country("AE", "United Arab Emirates"),
    country("TH", "Thailand"), country("NZ", "New Zealand"), country("EG", "Egypt")
];

// "Credits" demo: a wallet-style balance, not a data cap - size/availableBalance
// are denominated in the purchase currency (sizeUnit === price.currencyCode)
// rather than GB, and there's no expiry, so validity never kicks in.
function dates() {
    return {
        activatedAt: iso(-20 * DAY_MS),
        expiresAt: iso(100 * 365 * DAY_MS),
        salesDate: iso(-20 * DAY_MS - 60 * 60 * 1000)
    };
}

export function getMockCustomerProfile() {
    const {activatedAt, expiresAt, salesDate} = dates();

    return {
        totalAvailableBalance: {sizeValue: 6.4, sizeUnit: "USD"},
        balances: [
            {
                price: {priceValue: 10, currencyCode: "USD"},
                salesDate,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                includedCountries: GLOBAL_COUNTRIES,
                balance: {
                    name: "Global Data Credits",
                    activatedAt,
                    expiresAt,
                    activationMode: "NOW",
                    size: {sizeValue: 10, sizeUnit: "USD"},
                    availableBalance: {sizeValue: 6.4, sizeUnit: "USD"},
                    validitySize: 0, validityUnit: "days",
                    countrySet: "glb",
                    extendedDataPolicy: null
                }
            }
        ],
        relatedEsims: [
            {
                uid: "esim-uid-002",
                active: true,
                state: "Installed",
                iccid: MOCK_ICCID,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                activatedAt,
                lastSeen: iso(-20 * 60 * 1000),
                installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
                appleUniversalLink: "https://example.com/esim/apple-install",
                androidUniversalLink: "https://example.com/esim/android-install",
                activationCode: MOCK_ACTIVATION_CODE,
                imsi: ""
            }
        ],
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}

export function getMockEsimData() {
    const {activatedAt, expiresAt} = dates();

    return {
        esimProfile: {
            uid: "esim-uid-002",
            active: true,
            state: "Installed",
            iccid: MOCK_ICCID,
            customerProfileDomainId: MOCK_DOMAIN_ID,
            activatedAt,
            lastSeen: iso(-20 * 60 * 1000),
            installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
            appleUniversalLink: "https://example.com/esim/apple-install",
            androidUniversalLink: "https://example.com/esim/android-install",
            activationCode: MOCK_ACTIVATION_CODE,
            imsi: ""
        },
        balances: [
            {
                name: "Global Data Credits",
                activatedAt,
                expiresAt,
                activationMode: "NOW",
                size: {sizeValue: 10, sizeUnit: "USD"},
                availableBalance: {sizeValue: 6.4, sizeUnit: "USD"},
                validitySize: 0, validityUnit: "days",
                countrySet: "glb",
                extendedDataPolicy: null
            }
        ],
        totalAvailableBalance: {sizeValue: 6.4, sizeUnit: "USD"},
        customerProfileUrl: "https://example.com/customer/profile?token=mock-customer-token",
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}
